import { render, staticRenderFns } from "./perm.vue?vue&type=template&id=f608abba&"
import script from "./perm.vue?vue&type=script&lang=js&"
export * from "./perm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports